import { formatDate } from "../../../utils/dateTimeUtil";
export var getPublisherListColumns = function (formatMessage, onRowClick) { return [
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.name",
        }),
        key: "name",
        clickable: true,
        onClick: onRowClick,
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.nameSuffix",
        }),
        key: "nameSuffix",
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.qualifier",
        }),
        key: "qualifier",
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.companyNumber",
        }),
        key: "companyNumber",
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.birthDate",
        }),
        key: "birthDate",
        cellRenderer: function (item) {
            return item.birthDate ? formatDate(item.birthDate) : "";
        },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.publishers.table.columns.status",
        }),
        key: "status",
        formatter: function (item) {
            return formatMessage({
                id: "ui-br-publishers.status.".concat(item.status.toLowerCase()),
            });
        },
    },
]; };
